import React from "react";
//#region types
import {DocumentDraftVoucherIconsProps } from "models/propTypes/documentDraftPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Icon, SimpleTooltip } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

const DocumentDraftVoucherIcons: React.FC<DocumentDraftVoucherIconsProps> = (props) => {
  const getIcon = (type: WintSuperkollAPIModel.DocumentDraftType) => {
    switch (type) {
      case WintSuperkollAPIModel.DocumentDraftType.Receipt:
        return IconDefinitionConstants.WReceipt;
      case WintSuperkollAPIModel.DocumentDraftType.IncomingInvoice:
        return IconDefinitionConstants.WSupplierInvoice;
      case WintSuperkollAPIModel.DocumentDraftType.GenericDocument:
        return IconDefinitionConstants.WGenericDocument;
      case WintSuperkollAPIModel.DocumentDraftType.SelfInvoice:
        return IconDefinitionConstants.WPaperPlane;
      default:
        return IconDefinitionConstants.WQuestionCircle;
    }
  };

  const getTooltipText = (type: WintSuperkollAPIModel.DocumentDraftType) => {
    switch (type) {
      case WintSuperkollAPIModel.DocumentDraftType.Receipt:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.ShowReceipt);
      case WintSuperkollAPIModel.DocumentDraftType.IncomingInvoice:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.ShowInvoice);
      case WintSuperkollAPIModel.DocumentDraftType.GenericDocument:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.ShowGenericDocument);
      case WintSuperkollAPIModel.DocumentDraftType.SelfInvoice:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.ShowSelfInvoice);
      default:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Unknown);
    }
  };

  return (
    <SimpleTooltip placement="top" text={getTooltipText(props.type)}>
      <div className={cssExports.tableToolTip}>
        <Icon
          icon={getIcon(props.type)}
        />
      </div>
    </SimpleTooltip>
  );
};

export default DocumentDraftVoucherIcons;
